"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyFactory = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _remeda = require("remeda");
/*
Adapted from Grapes.js https://github.com/artf/grapesjs

Copyright (c) 2017-2022, Artur Arseniev
All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

- Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.
- Redistributions in binary form must reproduce the above copyright notice, this
  list of conditions and the following disclaimer in the documentation and/or
  other materials provided with the distribution.
- Neither the name "GrapesJS" nor the names of its contributors may be
  used to endorse or promote products derived from this software without
  specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. 
 */

const getOptions = items => items.map(item => ({
  id: item
}));
function mapFonts(group, fallback) {
  return it => {
    let gf = !it.includes(",");
    let id;
    if (gf) {
      id = `'${it}'`;
    } else {
      id = it;
    }
    return {
      font: it,
      fallback,
      id: `${id}, ${fallback}`,
      gf,
      group
    };
  };
}
const inheritedProperties = ["border-collapse", "border-spacing", "caption-side", "color", "cursor", "direction", "empty-cells", "font-family", "font-size", "font-style", "font-variant", "font-weight", "font-size-adjust", "font-stretch", "font", "letter-spacing", "line-height", "list-style-image", "list-style-position", "list-style-type", "list-style", "orphans", "quotes", "tab-size", "text-align", "text-align-last", "text-decoration-color", "text-indent", "text-justify", "text-shadow", "text-transform", "visibility", "white-space", "widows", "word-break", "word-spacing", "word-wrap"];
const ss = ["Helvetica, Arial", "Tahoma, Geneva", "Roboto", "Inter", "Open Sans", "Montserrat", "Raleway", "Oswald", "Fira Sans", "Barlow", "Quicksand", "Exo"].map(mapFonts("Sans Serif", "sans-serif"));
const serifs = ["Times New Roman, Times", "Merriweather", "Roboto Slab", "Lora", "Libre Baskerville", "Bitter", "Crimson Text", "Arvo", "Vollkorn"].map(mapFonts("Serif", "serif"));
const disps = ["Orbitron", "Lobster", "Rubik Dirt", "Abril Fatface", "Righteous", "Press Start 2P", "Playball"].map(mapFonts("Display", "sans-serif"));
const optsFlex = ["flex-start", "flex-end", "center"];
const optsFlexAlign = [...optsFlex, "baseline", "stretch"];
class PropertyFactory {
  constructor() {
    (0, _defineProperty2.default)(this, "unitsSize", ["px", "%", "em", "rem", "vh", "vw"]);
    (0, _defineProperty2.default)(this, "unitsFontSize", ["em", "rem", "px"]);
    (0, _defineProperty2.default)(this, "unitsSizeNoPerc", ["px", "em", "rem", "vh", "vw"]);
    (0, _defineProperty2.default)(this, "unitsTime", ["s", "ms"]);
    (0, _defineProperty2.default)(this, "unitsAngle", ["deg", "rad", "grad"]);
    (0, _defineProperty2.default)(this, "fixedValues", ["initial", "inherit", "auto"]);
    (0, _defineProperty2.default)(this, "optsBgSize", ["auto", "cover", "contain"]);
    (0, _defineProperty2.default)(this, "optsBgAttach", getOptions(["scroll", "fixed", "local"]));
    (0, _defineProperty2.default)(this, "optsBgRepeat", getOptions(["repeat", "repeat-x", "repeat-y", "no-repeat"]));
    (0, _defineProperty2.default)(this, "optsWrap", getOptions(["nowrap", "wrap", "wrap-reverse"]));
    (0, _defineProperty2.default)(this, "optsOverflow", getOptions(["visible", "hidden", "scroll", "auto"]));
    (0, _defineProperty2.default)(this, "optsDir", getOptions(["row", "row-reverse", "column", "column-reverse"]));
    (0, _defineProperty2.default)(this, "opstDisplay", getOptions(["block", "flex", "inline", "inline-block", "inline-flex", "none"]));
    (0, _defineProperty2.default)(this, "optsTransitFn", getOptions(["linear", "ease", "ease-in", "ease-out", "ease-in-out"]));
    (0, _defineProperty2.default)(this, "optsCursor", getOptions(["auto", "pointer", "copy", "crosshair", "grab", "grabbing", "help", "move", "text"]));
    (0, _defineProperty2.default)(this, "optsFloat", getOptions(["none", "left", "right"]));
    (0, _defineProperty2.default)(this, "optsPos", getOptions(["static", "relative", "absolute", "fixed"]));
    (0, _defineProperty2.default)(this, "optsTextAlign", getOptions(["left", "center", "right", "justify"]));
    (0, _defineProperty2.default)(this, "optsFlexAlign", getOptions(optsFlexAlign));
    (0, _defineProperty2.default)(this, "optsJustCont", getOptions([...optsFlex, "space-between", "space-around", "space-evenly"]));
    (0, _defineProperty2.default)(this, "optsAlignCont", getOptions([...optsFlex, "space-between", "space-around", "stretch"]));
    (0, _defineProperty2.default)(this, "optsAlignSelf", getOptions(["auto", ...optsFlexAlign]));
    (0, _defineProperty2.default)(this, "optsTransitProp", getOptions(["all", "width", "height", "background-color", "transform", "box-shadow", "opacity"]));
    (0, _defineProperty2.default)(this, "optsBorderStyle", getOptions(["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset"]));
    (0, _defineProperty2.default)(this, "optsBgPos", getOptions(["left top", "center top", "right top", "left center", "center center", "right center", "left bottom", "center bottom", "right bottom"]));
    (0, _defineProperty2.default)(this, "optsFit", getOptions(["fill", "contain", "cover", "scale-down", "none"]));
    (0, _defineProperty2.default)(this, "optsWeight", [{
      id: "400",
      label: "Normal"
    }, {
      id: "700",
      label: "Bold"
    }]);
    (0, _defineProperty2.default)(this, "optsStyle", [{
      id: "normal"
    }, {
      id: "italic"
    }]);
    (0, _defineProperty2.default)(this, "optsTextTransform", getOptions(["none", "capitalize", "uppercase", "lowercase"]));
    (0, _defineProperty2.default)(this, "optsWhitespace", getOptions(["normal", "nowrap", "pre", "pre-wrap", "pre-line", "break-spaces"]));
    (0, _defineProperty2.default)(this, "optsShadowType", [{
      id: "",
      label: "Outside"
    }, {
      id: "inset",
      label: "Inside"
    }]);
    (0, _defineProperty2.default)(this, "optsBackgroundClip", getOptions(["border-box", "padding-box", "content-box", "text"]));
    (0, _defineProperty2.default)(this, "optsFonts", [...ss, ...serifs, ...disps].map(font => {
      return {
        ...font,
        label: font.font
      };
    }));
    (0, _defineProperty2.default)(this, "optsBlendMode", getOptions(["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"]));
    // Fixed values
    (0, _defineProperty2.default)(this, "fixedFontSizes", ["medium", "small", "large", "inherit"]);
    (0, _defineProperty2.default)(this, "fixedLetSpace", ["normal", "initial", "inherit"]);
    (0, _defineProperty2.default)(this, "requireFlex", {
      display: ["flex", "inline-flex"]
    });
    (0, _defineProperty2.default)(this, "props", void 0);
    (0, _defineProperty2.default)(this, "compositeProperties", []);
    this.init();
  }
  __sub(items) {
    return () => items.map(p => {
      if (typeof p === "string") return this.get(p);
      const {
        extend,
        ...rest
      } = p;
      let prop = this.get(extend);
      return {
        ...prop,
        ...rest,
        extend
      };
    });
  }
  __stacked(stack, items) {
    return () => items.map(p => {
      const {
        extend,
        ...rest
      } = p;
      let prop = this.get(extend);
      prop.stack = stack;
      return {
        ...prop,
        ...rest
      };
    });
  }
  init() {
    const {
      fixedValues,
      requireFlex
    } = this;
    this.props = {};

    // Build default built-in properties (the order, in the array here below, matters)
    // [propertyName, propertyDefinition, extendFromProperty]
    let data = [
    // Number types
    ["text-shadow-h", {
      type: "number",
      default: "0",
      units: this.unitsSizeNoPerc
    }], ["top", {
      default: "auto",
      units: this.unitsSize,
      fixedValues,
      unitDefaults: "0"
    }, "text-shadow-h"], ["right", {}, "top"], ["bottom", {}, "top"], ["left", {}, "top"], ["margin-top", {
      default: "0"
    }, "top"], ["margin-right", {}, "margin-top"], ["margin-bottom", {}, "margin-top"], ["margin-left", {}, "margin-top"], ["padding-top", {
      min: 0
    }, "margin-top"], ["padding-right", {}, "padding-top"], ["padding-bottom", {}, "padding-top"], ["padding-left", {}, "padding-top"], ["width", {
      min: 0,
      unitDefaults: {
        px: "100",
        "%": "100",
        em: "10",
        rem: "10",
        vh: "10",
        vw: "10"
      }
    }, "top"], ["min-width", {}, "width"], ["max-width", {}, "width"], ["height", {}, "width"], ["min-height", {}, "width"], ["max-height", {}, "width"], ["flex-basis", {
      requiresParent: requireFlex
    }, "width"], ["column-gap", {
      requires: requireFlex,
      unitDefaults: "0"
    }, "width"], ["row-gap", {}, "column-gap"], ["font-size", {
      default: "1",
      units: this.unitsFontSize,
      fixedValues: this.fixedFontSizes,
      unitDefaults: {
        px: "14",
        em: "1",
        rem: "1",
        "%": "100"
      }
    }, "width"], ["letter-spacing", {
      default: "normal",
      fixedValues: this.fixedLetSpace,
      unitDefaults: "0"
    }, "top"], ["line-height", {}, "letter-spacing"], ["text-shadow-v", {}, "text-shadow-h"], ["text-shadow-blur", {
      min: 0
    }, "text-shadow-h"], ["border-radius-c", {
      property: "border-radius",
      fixedValues: undefined
    }, "padding-top"], ["border-top-left-radius", {}, "border-radius-c"], ["border-top-right-radius", {}, "border-radius-c"], ["border-bottom-left-radius", {}, "border-radius-c"], ["border-bottom-right-radius", {}, "border-radius-c"], ["border-width", {
      units: this.unitsSizeNoPerc,
      default: "0"
    }, "border-radius-c"], ["border-top-width", {}, "border-width"], ["border-right-width", {}, "border-width"], ["border-bottom-width", {}, "border-width"], ["border-left-width", {}, "border-width"], ["box-shadow-h", {}, "text-shadow-h"], ["box-shadow-v", {}, "text-shadow-h"], ["box-shadow-blur", {
      default: "5"
    }, "text-shadow-blur"], ["box-shadow-spread", {
      default: "0"
    }, "text-shadow-h"], ["transition-duration", {
      default: "2s",
      units: this.unitsTime
    }, "border-radius-c"], ["perspective", {}, "border-radius-c"], ["order", {
      type: "number",
      default: "0",
      requiresParent: requireFlex
    }], ["flex-grow", {}, "order"], ["flex-shrink", {
      default: "1"
    }, "order"], ["aspect-ratio", {
      type: "number"
    }], ["z-index", {
      type: "number",
      fixedValues,
      default: "auto",
      requires: {
        position: ["relative", "absolute", "fixed"]
      }
    }],
    // Radio types
    ["float", {
      type: "select",
      default: "none",
      options: this.optsFloat
    }], ["position", {
      default: "static",
      options: this.optsPos
    }, "float"], ["text-align", {
      default: "left",
      options: this.optsTextAlign
    }, "float"],
    // Color types
    ["color", {
      type: "color",
      default: "inherit"
    }], ["text-shadow-color", {}, "color"], ["border-color", {
      default: "black"
    }, "color"], ["border-top-color", {}, "border-color"], ["border-right-color", {}, "border-color"], ["border-bottom-color", {}, "border-color"], ["border-left-color", {}, "border-color"], ["box-shadow-color", {}, "border-color"], ["background-color", {
      default: "none"
    }, "color"],
    // File type
    ["background-image", {
      type: "file",
      functionName: "url",
      default: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)",
      full: true
    }],
    // Slider type
    ["opacity", {
      type: "slider",
      default: "1",
      min: 0,
      max: 1,
      step: 0.01
    }],
    // Select types
    ["display", {
      type: "select",
      default: "block",
      options: this.opstDisplay
    }], ["flex-direction", {
      default: "row",
      options: this.optsDir,
      requires: requireFlex
    }, "display"], ["flex-wrap", {
      default: "nowrap",
      options: this.optsWrap
    }, "flex-direction"], ["justify-content", {
      default: "flex-start",
      options: this.optsJustCont
    }, "flex-wrap"], ["align-items", {
      default: "stretch",
      options: this.optsFlexAlign
    }, "flex-wrap"], ["align-content", {
      options: this.optsAlignCont
    }, "align-items"], ["align-self", {
      default: "auto",
      options: this.optsAlignSelf,
      requiresParent: requireFlex
    }, "display"], ["font-family", {
      default: "",
      options: this.optsFonts
    }, "display"], ["font-weight", {
      default: "400",
      options: this.optsWeight
    }, "display"], ["font-style", {
      default: "normal",
      options: this.optsStyle
    }, "display"], ["text-transform", {
      default: "none",
      options: this.optsTextTransform
    }, "display"], ["white-space", {
      default: "normal",
      options: this.optsWhitespace
    }, "display"], ["background-clip", {
      default: "border-box",
      options: this.optsBackgroundClip
    }, "display"], ["border-style", {
      default: "solid",
      options: this.optsBorderStyle
    }, "display"], ["border-top-style", {}, "border-style"], ["border-right-style", {}, "border-style"], ["border-bottom-style", {}, "border-style"], ["border-left-style", {}, "border-style"], ["box-shadow-type", {
      default: "",
      options: this.optsShadowType
    }, "display"], ["background-repeat", {
      default: "repeat",
      options: this.optsBgRepeat
    }, "display"], ["background-position", {
      default: "left top",
      options: this.optsBgPos
    }, "display"], ["background-attachment", {
      default: "scroll",
      options: this.optsBgAttach
    }, "display"], ["background-size", {
      default: "auto",
      fixedValues: this.optsBgSize
    }, "top"], ["background-size-y", {
      default: "auto",
      fixedValues: ["auto"]
    }, "top"], ["transition-property", {
      default: "width",
      options: this.optsTransitProp
    }, "display"], ["transition-timing-function", {
      default: "ease",
      options: this.optsTransitFn
    }, "display"], ["cursor", {
      default: "auto",
      options: this.optsCursor
    }, "display"], ["overflow", {
      default: "visible",
      options: this.optsOverflow
    }, "display"], ["overflow-x", {}, "overflow"], ["overflow-y", {}, "overflow"], ["object-fit", {
      default: "fill",
      options: this.optsFit
    }, "display"], ["mix-blend-mode", {
      default: "normal",
      options: this.optsBlendMode
    }, "display"],
    // Composite types
    ["margin", {
      type: "composite",
      uniform: true,
      properties: this.__sub([{
        extend: "margin-top",
        id: "margin-top-sub"
      }, {
        extend: "margin-right",
        id: "margin-right-sub"
      }, {
        extend: "margin-bottom",
        id: "margin-bottom-sub"
      }, {
        extend: "margin-left",
        id: "margin-left-sub"
      }])
    }], ["padding", {
      properties: this.__sub([{
        extend: "padding-top",
        id: "padding-top-sub"
      }, {
        extend: "padding-right",
        id: "padding-right-sub"
      }, {
        extend: "padding-bottom",
        id: "padding-bottom-sub"
      }, {
        extend: "padding-left",
        id: "padding-left-sub"
      }])
    }, "margin"], ["positioning", {
      properties: this.__sub([{
        extend: "top",
        id: "positioning-top-sub"
      }, {
        extend: "right",
        id: "positioning-right-sub"
      }, {
        extend: "bottom",
        id: "positioning-bottom-sub"
      }, {
        extend: "left",
        id: "positioning-left-sub"
      }]),
      requires: {
        position: ["relative", "absolute", "fixed"]
      },
      virtual: true
    }, "margin"], ["border", {
      properties: this.__sub([{
        extend: "border-width",
        id: "border-width-sub"
      }, {
        extend: "border-style",
        id: "border-style-sub"
      }, {
        extend: "border-color",
        id: "border-color-sub"
      }])
    }, "margin"], ["border-top", {
      properties: this.__sub([{
        extend: "border-top-width",
        id: "border-top-width-sub"
      }, {
        extend: "border-top-style",
        id: "border-top-style-sub"
      }, {
        extend: "border-top-color",
        id: "border-top-color-sub"
      }]),
      uniform: false
    }, "margin"], ["border-right", {
      properties: this.__sub([{
        extend: "border-right-width",
        id: "border-right-width-sub"
      }, {
        extend: "border-right-style",
        id: "border-right-style-sub"
      }, {
        extend: "border-right-color",
        id: "border-right-color-sub"
      }])
    }, "border-top"], ["border-bottom", {
      properties: this.__sub([{
        extend: "border-bottom-width",
        id: "border-bottom-width-sub"
      }, {
        extend: "border-bottom-style",
        id: "border-bottom-style-sub"
      }, {
        extend: "border-bottom-color",
        id: "border-bottom-color-sub"
      }])
    }, "border-top"], ["border-left", {
      properties: this.__sub([{
        extend: "border-left-width",
        id: "border-left-width-sub"
      }, {
        extend: "border-left-style",
        id: "border-left-style-sub"
      }, {
        extend: "border-left-color",
        id: "border-left-color-sub"
      }])
    }, "border-top"], ["border-radius", {
      properties: this.__sub([{
        extend: "border-top-left-radius",
        id: "border-top-left-radius-sub"
      }, {
        extend: "border-top-right-radius",
        id: "border-top-right-radius-sub"
      }, {
        extend: "border-bottom-right-radius",
        id: "border-bottom-right-radius-sub"
      }, {
        extend: "border-bottom-left-radius",
        id: "border-bottom-left-radius-sub"
      }])
    }, "margin"],
    // Stack types
    ["transition", {
      type: "stack",
      properties: this.__sub([{
        extend: "transition-property",
        id: "transition-property-sub"
      }, {
        extend: "transition-duration",
        id: "transition-duration-sub"
      }, {
        extend: "transition-timing-function",
        id: "transition-timing-function-sub"
      }])
    }], ["box-shadow", {
      preview: true,
      layerLabel: (l, {
        values
      }) => {
        const x = values["box-shadow-h"];
        const y = values["box-shadow-v"];
        const blur = values["box-shadow-blur"];
        const spread = values["box-shadow-spread"];
        return `${x} ${y} ${blur} ${spread}`;
      },
      properties: this.__sub(["box-shadow-h", "box-shadow-v", "box-shadow-blur", "box-shadow-spread", "box-shadow-color", "box-shadow-type"])
    }, "transition"], ["text-shadow", {
      default: "none",
      layerLabel: (l, {
        values
      }) => {
        const x = values["text-shadow-h"];
        const y = values["text-shadow-v"];
        const blur = values["text-shadow-blur"];
        return `${x} ${y} ${blur}`;
      },
      properties: this.__sub(["text-shadow-h", "text-shadow-v", "text-shadow-blur", "text-shadow-color"])
    }, "box-shadow"], ["background", {
      detached: true,
      layerLabel: (l, {
        values
      }) => {
        const repeat = values["background-repeat-sub"] || "";
        const pos = values["background-position-sub"] || "";
        const att = values["background-attachment-sub"] || "";
        const size = values["background-size-sub"] || "";
        return [repeat, pos, att, size].join(" ");
      },
      properties: this.__stacked("background", [{
        extend: "background-image",
        id: "background-image-sub"
      }, {
        extend: "background-repeat",
        id: "background-repeat-sub"
      }, {
        extend: "background-position",
        id: "background-position-sub"
      }, {
        extend: "background-size",
        id: "background-size-sub"
      }, {
        extend: "background-size-y",
        id: "background-size-y-sub"
      }])
    }, "box-shadow"], ["transform", {
      type: "stack",
      layerSeparator: " ",
      fromStyle(style, {
        property,
        name
      }) {
        const filter = style[name] || "";
        const sep = property.getLayerSeparator();
        return filter ? filter.split(sep).map(input => {
          const {
            name,
            value
          } = property.__parseFn(input);
          return {
            name,
            value
          };
        }) : [];
      },
      toStyle(values, {
        name
      }) {
        return {
          [name]: `${values.name}(${values.value})`
        };
      },
      properties: [{
        property: "name",
        name: "Type",
        type: "select",
        default: "rotateZ",
        full: true,
        options: [{
          id: "scaleX",
          propValue: {
            units: [""],
            step: 0.01
          }
        }, {
          id: "scaleY",
          propValue: {
            units: [""],
            step: 0.01
          }
        }, {
          id: "scaleZ",
          propValue: {
            units: [""],
            step: 0.01
          }
        }, {
          id: "rotateX",
          propValue: {
            units: this.unitsAngle,
            step: 1
          }
        }, {
          id: "rotateY",
          propValue: {
            units: this.unitsAngle,
            step: 1
          }
        }, {
          id: "rotateZ",
          propValue: {
            units: this.unitsAngle,
            step: 1
          }
        }, {
          id: "translateX",
          propValue: {
            units: this.unitsSize,
            step: 1
          }
        }, {
          id: "translateY",
          propValue: {
            units: this.unitsSize,
            step: 1
          }
        }],
        onChange({
          property,
          to
        }) {
          if (to.value) {
            const option = property.getOption();
            const props = {
              ...(option.propValue || {})
            };
            const propToUp = property.getParent().getProperty("value");
            const unit = propToUp.getUnit();
            if (!unit || (props === null || props === void 0 ? void 0 : props.units.indexOf(unit)) < 0) {
              props.unit = (props === null || props === void 0 ? void 0 : props.units[0]) || "";
            }
            propToUp.up(props);
          }
        }
      }, {
        property: "value",
        type: "number",
        default: "0",
        full: true
      }]
    }]];
    data.forEach(([prop, def, from]) => {
      this.add(prop, def || {}, {
        from
      });
    });
    for (let it of Object.values(this.props)) {
      Object.freeze(it);
    }
    return this;
  }
  add(property, def = {}, opts = {}) {
    const from = opts.from || "";
    const fromRes = this.props[from || property];
    const result = {
      ...fromRes,
      property,
      ...(0, _remeda.omit)(def, ["properties"])
    };
    if (result.type === "composite" || result.type === "stack") {
      let cdef = def;
      if (typeof cdef.properties === "function") {
        result.properties = cdef.properties();
      } else {
        result.properties = cdef.properties;
      }
      if (result.type === "composite" && !result.virtual) {
        for (let it of result.properties) {
          if (it.extend) {
            this.compositeProperties.push(it.extend);
          }
        }
      }
    } else {
      if (inheritedProperties.includes(property)) {
        result.inherited = true;
      } else {
        result.inherited = false;
      }
    }
    this.props[property] = result;
    return result;
  }
  get(prop) {
    return this.props[prop] || null;
  }

  /**
   * Build props object by their name
   * @param  {Array<string>|string} props Array of properties name
   * @return {Array<Object>}
   */
  build(props) {
    const result = [];
    const propsArr = typeof props === "string" ? [props] : props;
    propsArr.forEach(prop => {
      result.push(this.get(prop) || {
        id: prop,
        property: prop,
        type: "number"
      });
    });
    return result;
  }
}
exports.PropertyFactory = PropertyFactory;
//# sourceMappingURL=PropertyFactory.js.map